import { generateUtilityClasses } from '../../utils';

export const keyValuePairsSkeletonClasses = generateUtilityClasses('KeyValuePairsSkeleton', [
  'root',
  'row',
  'divider',
  'group',
  'column',
  'label',
  'value',
]);
